import { CarrierStatus } from "../../../shared/enums/enum";
import { AddressResponseModel } from "../../../shared/models/response-models/address.model";

export class CarrierModel {
  id!: number;
  name!: string;
  carrierCode!: string;
  description!: string;
  status: CarrierStatus = CarrierStatus.Active;
  email!: string;
  phoneNumber!: string;
  fax!: string;
  websiteUrl!: string;
  companyId!: number;
  isDefault!: boolean;
  primaryContact!: PrimaryContactModel;
  address!: AddressResponseModel;

  constructor(init?: Partial<CarrierModel>) {
    Object.assign(this, init);
    this.primaryContact = new PrimaryContactModel(init?.primaryContact);
    this.address = new AddressResponseModel(init?.address);
  }
}

export class PrimaryContactModel {
  firstName!: string;
  lastName!: string;
  email!: string;
  phoneNumber!: string;

  constructor(init?: Partial<PrimaryContactModel>) {
    Object.assign(this, init);
  }
}

